'use strict';

var Constructor = require('js/vendor/constructor');
var _ = require('underscore');


/**
 * Core lib ComposerDefinition module [[Tests]](../test.html?grep=lib/composer/definition)
 * --------------------
 * This class allows you to 'compose' an object and store it in memory until a point you invalidate it.
 *
 * @exports Definition
 * @constructor
 * @alias module:lib/composer/definition
 */
var Definition = Constructor.extend();

Definition.prototype.instance = null;
Definition.prototype._compose = null;
Definition.prototype._context = null;
Definition.prototype._isValid = null;

/**
 * Compose an object.
 * @callback compose
 */

/**
 * Validate an object.
 * @callback isValid
 * @return Bool
 */

/**
 * Initialise a definition with given compose and validation callbacks and a context
 * @param  {compose}  compose The composer function for creating the stored object
 * @param  {isValid} isValid The validation function for telling when to get rid of this instance
 * @param  {Object}  context Context to bind this definition to
 */
Definition.prototype.initialize = function(compose, isValid, context) {
  if (!_.isFunction(isValid)) {
    context = isValid;
    isValid = function() {
      return true;
    };
  }

  this.compose(compose)
    .validate(isValid)
    .context(context);

  this.instance = null;
};

/**
 * Fetch the value of our stored instance. This is where we will call the compose callback.
 * @return {Object} Whatever is composed.
 */
Definition.prototype.fetch = function() {
  if (this.instance === null) {
    this.instance = this._compose.call(this._context);
  }

  return this.instance;
};

/**
 * Invalidate this definition (remove ref to instance) if invalid or force is true
 * @param  {Boolean} force Force a deref
 */
Definition.prototype.invalidate = function(force) {
  if (force || !this._isValid.call(this._context, this.instance)) {
    this.instance = null;
  }

  return this;
};

/**
 * Set validation callback
 * @param  {isValid} isValid Validation callback
 * @return {this}          Return definition for chaining
 */
Definition.prototype.validate = function(isValid) {
  this._isValid = isValid;

  return this; // Allow chaining
};

/**
 * Set compose callback
 * @param  {compose} compose Composition callback
 * @return {this}          Return definition for chaining
 */
Definition.prototype.compose = function(compose) {
  this._compose = compose;

  return this; // Allow chaining
};

/**
 * Set context
 * @param  {Object} context Definition context
 * @return {this}          Return definition for chaining
 */
Definition.prototype.context = function(context) {
  this._context = context;

  return this; // Allow chaining
};

module.exports = Definition;



// WEBPACK FOOTER //
// ./app/assets/js/lib/composer/definition.js